import { useState } from "react";
import { RegisterUserCommand } from "../types/AuthTypes";
import { registerUser } from "../services/authService";
import "../styles/form.css";

const roles = ["User", "Admin", "SuperAdmin"];

interface RegisterUserFormProps {
  loadUsers: () => void;
}


const RegisterUserForm: React.FC<RegisterUserFormProps> = ({ loadUsers }) => {
  const [formData, setFormData] = useState<RegisterUserCommand>({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    var response = await registerUser(formData);

    if (response === null)
    {
      alert("Failed to register user.");
    }
    else
    {
      if (response.isError)
      {
        alert(response.message);
      }
      else
      {
        alert("User registered successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          role: "",
        })
        loadUsers();
      }
    }
  };

  return (
    <div className="form-container">
      <h2 className="text-xl font-bold mb-4">Register New User</h2>
      <form onSubmit={handleSubmit} className="space-y-4">

        <div className="input-group">
            <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
            />

            <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
            />

            <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            />

            <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
            />

            <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                >
                <option value={0}>Please select User role</option>
                {roles.map((r) => (
                    <option key={r} value={r}>
                    {r}
                    </option>
                ))}
            </select>
        </div>

        <button
          type="submit"
          className="submit-button bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded"
        >
          Register
        </button>
      </form>
    </div>
  );
};

export default RegisterUserForm;